import { httpClient } from "util/Api";
import { config } from "util/config";
import * as globalFunction from 'util/GlobalFunction';
import moment from 'moment';

export function formatData({ parameter, pageComponent } = {}) {
  let check = false;
  parameter.map(item => {
    if (item.DateResolved === null) {
      check = true;
    }
  })

  setTimeout(() => {
    pageComponent.sectionNavigation.current?.state.page?.sectionList.map(item => {
      if (item.name === 'BuildingWorkEnforcement') {
        if (check) {
          item.className = 'red red-border';
        } else {
          item.className = '';
        }
      }
      return item;
    });
  }, 50);
}

//弹出添加DIV后触发
export function addBuildingWorkEnforcementPopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  getDataSource({ parameter, sectionComponent, pageComponent, sectionName, type: 'Create' });
  sectionComponent.customForm.current?.formRef.current?.setFieldValue('IssueDate', moment(new Date(), config.format.date));
}

//弹出编辑DIV后触发
export function editBuildingWorkEnforcementPopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  getDataSource({ parameter, sectionComponent, pageComponent, sectionName, type: 'Edit' });
  enforcementTypeChange({ parameter: sectionComponent.customForm.current?.formRef.current?.getFieldValue('EnforcementType'), pageComponent });
}

function getDataSource({ parameter, sectionComponent, pageComponent, sectionName, type } = {}) {
  httpClient
    .get('Business/SubJob/GetSelectOptionGroupList?jobId=' + pageComponent.state.jobData.JobId)
    .then(({ data }) => {
      if (data.result) {
        if (data.data.length > 0) {
          let componentDataSource = sectionComponent.customForm.current?.state.componentDataSource;
          let dataSource = data.data;
          componentDataSource['SubJobId'] = dataSource;
          sectionComponent.customForm.current?.setState({ componentDataSource });
          if (type === 'Create') {
            sectionComponent.customForm.current?.formRef.current?.setFieldValue('SubJobId', dataSource[0].Value);
          }
        }
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });

  httpClient
    .get('Business/BuildingWorkEnforcement/GetNoticeSelectOptionList?jobId=' + pageComponent.state.jobData.JobId)
    .then(({ data }) => {
      if (data.result) {
        if (data.data.length > 0) {
          let componentDataSource = sectionComponent.customForm.current?.state.componentDataSource;
          componentDataSource['RelevantEnforcementId'] = data.data;
          sectionComponent.customForm.current?.setState({ componentDataSource });
          if (type === 'Create') {
            sectionComponent.customForm.current?.formRef.current?.setFieldValue('RelevantEnforcementId', data.data[0].Value);
          }
        }
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

//EnforcementType改变时触发
export function enforcementTypeChange({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  if (parameter === 1) {
    globalFunction.setUieVisible(pageComponent, 'BuildingWorkEnforcement', 'Create', 'RelevantEnforcementId', false);
    globalFunction.setUieVisible(pageComponent, 'BuildingWorkEnforcement', 'Edit', 'RelevantEnforcementId', false);
  } else {
    globalFunction.setUieVisible(pageComponent, 'BuildingWorkEnforcement', 'Create', 'RelevantEnforcementId', true);
    globalFunction.setUieVisible(pageComponent, 'BuildingWorkEnforcement', 'Edit', 'RelevantEnforcementId', true);
  }
}

export function addSubmitFinish({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  globalFunction.getSectionComponent(pageComponent, 'JobTask')?.getSectionDataByDefault();
}

export function editSubmitFinish({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  globalFunction.getSectionComponent(pageComponent, 'JobTask')?.getSectionDataByDefault();
}

export function quickDueDateChange({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  if (parameter > 0) {
    let date = sectionComponent.customForm.current?.formRef.current?.getFieldValue('IssueDate');
    if (date !== undefined) {
      sectionComponent.customForm.current?.formRef.current?.setFieldValue('DueDate', globalFunction.addDateMoment(date, parameter));
    } else {
      sectionComponent.customForm.current?.formRef.current?.setFieldValue('DueDate', null);
    }
  }
}

//弹出mailmerge的div
export function docMergeBuildingWorkEnforcement({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  console.log(parameter);
  pageComponent.setState({ mailMergeTemplateShow: true, mailMergeObjId: parameter.BuildingWorkEnforcementId, mailMergeObj: parameter, dataModelType: 6 });
  setTimeout(() => {
    pageComponent.mailMergeTemplate.current?.getMailMergeTemplate(6, parameter.BuildingWorkEnforcementId);
  }, config.setTimeoutMilliSecond);
}

export function enforcementReasonTemplateChange({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  if (parameter !== 0) {
    httpClient
      .get('Admin/BuildingWorkEnforcementTemplate/' + parameter)
      .then(({ data }) => {
        if (data.result) {
          sectionComponent.customForm.current?.formRef.current?.setFieldValue('IssueReason', data.data.Content);
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }
}

export function enforcementContentTemplateChange({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  if (parameter !== 0) {
    httpClient
      .get('Admin/BuildingWorkEnforcementTemplate/' + parameter)
      .then(({ data }) => {
        if (data.result) {
          sectionComponent.customForm.current?.formRef.current?.setFieldValue('EnforcementContent', data.data.Content);
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }
}
